<template>
  <section id="team" class="team">
    <div class="container">
      <div class="section-header">
        <h2>{{ $t('team.title') }}</h2>
        <p class="description">{{ $t('team.description') }}</p>
        <ul class="highlights-list">
          <li v-for="(item, i) in $tm('team.highlights')" :key="i">{{ $rt(item) }}</li>
        </ul>
      </div>
      <div class="team-grid">
        <div v-for="member in $tm('team.members')" :key="member.name" class="member-card">
          <div class="member-image">
            <img :src="getImage(member.imageKey)" :alt="`Portrait of ${member.name}, ${member.role} at Data Do GmbH`" />
          </div>
          <div class="member-info">
            <h3>{{ member.name }}</h3>
            <p class="role">{{ member.role }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import marcImg from '@/assets/team/about_marc.jpg'
import saidahImg from '@/assets/team/about_saichi.jpg'

const getImage = (key) => {
  const images = {
    marc: marcImg,
    saidah: saidahImg
  }
  return images[key]
}
</script>

<style scoped>
.team {
  padding: 80px 20px;
  background-color: var(--white);
}

.container {
  max-width: 1000px;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

h2 {
  font-size: 2.5rem;
  margin-bottom: 20px;
  color: var(--text-color);
}

.description {
  max-width: 800px;
  margin: 0 auto;
  font-size: 1.1rem;
  line-height: 1.6;
  opacity: 0.8;
}

.highlights-list {
  max-width: 800px;
  margin: 16px auto 0;
  padding-left: 20px;
  text-align: left;
  font-size: 1.05rem;
  line-height: 1.8;
  opacity: 0.8;
}

.highlights-list li {
  margin-bottom: 4px;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px;
  justify-content: center;
}

.member-card {
  background-color: var(--white);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
  transition: transform 0.3s ease;
  text-align: center;
}

.member-card:hover {
  transform: translateY(-5px);
}

.member-image {
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
}

.member-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.member-card:hover .member-image img {
  transform: scale(1.05);
}

.member-info {
  padding: 25px;
}

h3 {
  margin-bottom: 10px;
  color: var(--primary-color);
}

.role {
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--text-color);
  opacity: 0.7;
}

@media (max-width: 768px) {
  .team-grid {
    grid-template-columns: 1fr;
    max-width: 400px;
    margin: 0 auto;
  }
}
</style>
